import { useEffect, useState } from 'react';

const N = (x: any) => (Number(x) || 0).toLocaleString();
const secs = (s: any) => { const n = Number(s) || 0; const m = Math.floor(n / 60); const r = n % 60; return `${m}:${String(r).padStart(2, '0')}`; };
function Tile({ v, l }: { v: any; l: string }) {
  return <div className="card p-3"><div className="text-xl font-semibold">{v}</div><div className="text-[11px] text-gray-500">{l}</div></div>;
}
const iso = (d: Date) => d.toISOString().slice(0, 10);

export default function CdrContactCenter() {
  const today = new Date();
  const [from, setFrom] = useState(iso(new Date(today.getTime() - 30 * 86400000)));
  const [to, setTo] = useState(iso(today));
  const [d, setD] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  function applyRange(days: number) {
    const t = iso(new Date());
    const f = iso(new Date(Date.now() - days * 86400000));
    setFrom(f); setTo(t); load(f, t);
  }
  async function load(f: string = from, t: string = to) {
    setBusy(true); setErr(null);
    try {
      const p = new URLSearchParams({ from: f, to: t + 'T23:59:59Z' });
      const r = await fetch('/cdr/api/cc?' + p.toString(), { credentials: 'include' });
      const j = await r.json();
      if (!r.ok) { setErr(j.error || 'error'); setD(null); } else { setD(j); }
    } catch (e: any) { setErr(String(e)); }
    setBusy(false);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const T = d?.totals || {};
  const dl = (rows: any[], name: string, cols: [string, string][]) => {
    if (!rows?.length) return;
    const csv = [cols.map(c => c[1]).join(',')].concat(rows.map(r => cols.map(c => (typeof r[c[0]] === 'string' ? `"${(r[c[0]] || '').replace(/"/g, '""')}"` : (r[c[0]] ?? 0))).join(',')));
    const b = new Blob([csv.join('\n')], { type: 'text/csv' }); const a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = name + '.csv'; a.click();
  };
  const dimCols: [string, string][] = [['k', 'Name'], ['calls', 'Calls'], ['abandoned', 'Abandoned'], ['avg_wait_s', 'Avg wait (s)'], ['avg_talk_s', 'Avg talk (s)']];
  const Grid = ({ title, rows, klabel }: { title: string; rows: any[]; klabel: string }) => (
    <div className="card p-3 overflow-auto">
      <div className="flex items-center justify-between mb-2"><div className="text-sm font-semibold">{title}</div><button onClick={() => dl(rows, title.replace(/\W+/g, '_'), dimCols)} className="text-[11px] px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-800">CSV</button></div>
      <table className="w-full text-xs"><thead className="text-gray-500"><tr><th className="text-left px-2 py-1">{klabel}</th><th className="text-right px-2 py-1">Calls</th><th className="text-right px-2 py-1">Abandoned</th><th className="text-right px-2 py-1">Avg wait</th><th className="text-right px-2 py-1">Avg talk</th></tr></thead>
        <tbody>{(rows || []).map((r: any, i: number) => <tr key={i} className="border-t border-gray-100 dark:border-gray-800"><td className="px-2 py-1">{r.k || <span className="text-gray-400">(none)</span>}</td><td className="px-2 py-1 text-right">{N(r.calls)}</td><td className="px-2 py-1 text-right">{N(r.abandoned)}</td><td className="px-2 py-1 text-right">{secs(r.avg_wait_s)}</td><td className="px-2 py-1 text-right">{secs(r.avg_talk_s)}</td></tr>)}</tbody></table>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="flex gap-2 items-center flex-wrap">
        <span className="text-xs text-gray-500">From</span><input type="date" value={from} onChange={e => setFrom(e.target.value)} className="border rounded-md px-2 py-1 text-xs bg-transparent" />
        <span className="text-xs text-gray-500">To</span><input type="date" value={to} onChange={e => setTo(e.target.value)} className="border rounded-md px-2 py-1 text-xs bg-transparent" />
        <button onClick={() => load()} className="px-3 py-1.5 rounded-md bg-tnh-accent text-white text-xs">Apply</button>
        <div className="flex gap-1">
          {[['30d', 30], ['90d', 90], ['12mo', 365]].map(([lbl, dys]) => (
            <button key={lbl as string} onClick={() => applyRange(dys as number)} className="px-2 py-1 rounded-md bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-[11px]">{lbl}</button>
          ))}
        </div>
        {busy && <span className="text-xs text-gray-500">Loading…</span>}
        {d?.coverage && <span className="text-xs text-gray-500 ml-auto">Ingested {N(d.coverage.n)} tasks · {d.coverage.d0 || '—'} → {d.coverage.d1 || '—'}</span>}
      </div>
      {err && <div className="text-xs text-red-500">Sign in to the CDR portal to view ({err}).</div>}

      {d && (<>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          <Tile v={N(T.calls)} l="Contact Center calls" />
          <Tile v={N(T.handled)} l="Handled by agent" />
          <Tile v={N(T.abandoned)} l="Abandoned" />
          <Tile v={secs(T.avg_wait_s)} l="Avg wait time" />
          <Tile v={secs(T.avg_talk_s)} l="Avg talk time" />
          <Tile v={N(T.after_hours)} l="After hours (5pm–8am)" />
          <Tile v={N(T.transfers)} l="Transfers" />
          <Tile v={N(T.within_sl)} l="Within SLA" />
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <Grid title="Most‑selected menu option (IVR)" rows={d.by_menu} klabel="Menu option" />
          <Grid title="By DNIS (number dialed)" rows={d.by_dnis} klabel="DNIS" />
          <Grid title="By Agent" rows={d.by_agent} klabel="Agent" />
          <Grid title="By Queue" rows={d.by_queue} klabel="Queue" />
          <div className="card p-3 overflow-auto">
            <div className="text-sm font-semibold mb-2">Transfers by outcome</div>
            <table className="w-full text-xs"><thead className="text-gray-500"><tr><th className="text-left px-2 py-1">Status</th><th className="text-right px-2 py-1">Calls</th></tr></thead>
              <tbody>{(d.transfers || []).map((r: any, i: number) => <tr key={i} className="border-t border-gray-100 dark:border-gray-800"><td className="px-2 py-1">{r.k}</td><td className="px-2 py-1 text-right">{N(r.calls)}</td></tr>)}
                {!(d.transfers || []).length && <tr><td colSpan={2} className="px-2 py-2 text-gray-400">No transfers in range.</td></tr>}</tbody></table>
          </div>
        </div>
        <div className="text-[11px] text-gray-400">Source: WxCC Analyzer (taskDetails + flow globalVariables). Durations in mm:ss. IVR menu selections read from the flow's option variables (e.g. Building_Safety_Opt3). Historical backfill fills toward 12 months automatically.</div>
      </>)}
    </div>
  );
}
